import { useAppTheme } from "../../../hooks/useAppTheme";
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import {
  StyleSheet,
  ScrollView,
  Text,
  TouchableOpacity,
  View as RNView,
  Pressable,
  Platform,
  Modal as RNModal,
} from "react-native";
import { DataTable, ThemeProvider, useTheme as usePaperTheme } from "react-native-paper";
import { View } from "../../../components/shared/Themed";
import { LabelBannerWithSearchBar } from "../../../components/custom/Banners/LabelBannerWithSearchBar";
import { DataTableWithPagination } from "../../../components/custom/DataTable/DataTableWithPagination";
import Spinner from "../../../components/shared/Spinner";
import { Feather, Ionicons } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getReserveStocks, getStocks } from "../../../services/stockService";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import {
  headersStock,
  mediumDeviceHeadersStock as mdStock,
  smallDeviceHeadersStock as smStock,
} from "../utils/stockHeaders";
import { reserveStockModel, stockModel } from "../../../models/reportsModel";
import { handleTableLoader } from "../../../utils/common";
import { useSelector } from "react-redux";
import { userClaimInformation } from "../../../models/usersModel";
import { useIsFocused } from "@react-navigation/native";
import { sortColumns } from "../../../utils/sortColumns";
import { filterBasedOnAnyKey } from "../../../utils/searchInArrays";
import { renameLabel } from "../../../utils/common";
import { StockReportDisplaySwitch } from "./utils/StockReportDisplaySwitch";
import { ReportsDispatcher } from "../../../redux/dispatcher/reportsDispatcher";
import { actionTypesReports } from "../../../redux/constants/actionTypesReports";
import { formatDate } from "../../../utils/dateUtility";
import {
  headersReserveStock,
  inlineOrderReservedHeaders,
} from "../utils/reserveStockHeaders";
import {
  translateHeaders,
  translateFields,
  useTranslation,
} from "../../../utils/useTranslation";
import { stockReportTranslationMap } from "../../../utils/translations";
import { default as Modal } from "../../../components/custom/Modal";
import { validSignedURLWithExt } from "../../../utils/validateSignedUrl";
import { getS3SignUrl } from "../../../services/s3BucketService";
export default function StocksReportScreen({ route, navigation }: any) {
  const { colors, isDark } = useAppTheme();
  const paperTheme = usePaperTheme();
  const { t } = useTranslation();
  const isFocused = useIsFocused();
  const listRef = useRef<ScrollView>(null);
  const stockFilterStyles = React.useMemo(() => getStockFilterStyles(colors), [colors]);

  const [stocksPageLevelList, setStocksPageLevelList] = useState<
    Array<stockModel>
  >([]);

  const [isSearched, setIsSearched] = useState<boolean>(false);

  const { userInfo, language } = useSelector(
    (state: any) => state.configurations,
  );
  const {
    stockReportList,
    isStockReportListLoaded,
    stockReportFilterCategoryList,
    lastRefreshStockReport,
    reserveStockReport,
    isReserveStockReportListLoaded,
  } = useSelector((state: any) => state.reports);

  const [selected, setSelected] = useState<stockModel>({} as stockModel);
  const [tableHeaders, setTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      headersStock,
    );
  const [searchedText, setSearchedText] = useState<string>("");
  const [lastRefresh, setLastRefresh] = useState<string>("");
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [, setFabOpen] = useState<Record<string, boolean>>({
    open: false,
  });
  const [isRefresh, setRefresh] = useState<boolean>(false);
  const [isImageLoading, setImageLoading] = useState<boolean>(true);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [contentOffSet, setContentOffSet] = useState<number>(0);

  const [_isDisplayViewOn, _setIsDisplayViewOn] = useState(false);
  const [_filterCategory, _setFilterCategory] = useState<string>("all");
  const [mobileFilterMenu, setMobileFilterMenu] = useState<"product" | "state" | null>(null);
  const productCategories = ["produce", "berry", "meat", "meals", "salad", "bakery"];
  const stateCategories = ["NSW", "VIC", "QLD", "WA", "SA", "TAS"];
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [showMobileFilters, setShowMobileFilters] = useState<boolean>(false);
  const [orderReservedLookup, setOrderReservedLookup] = useState<
    Record<string, Array<reserveStockModel>>
  >({});
  const [mobilePage, setMobilePage] = useState<number>(0);
  const itemsPerPage = 20;

  const { isLargeDevice, isMediumDevice, isMobileDevice, isSmallDevice } =
    useContext(DeviceOrientationContext);

  const cardStyles = createCardStyles(colors, isDark);
  const [reservedModalVisible, setReservedModalVisible] = useState<boolean>(false);
  const [selectedReservedStock, setSelectedReservedStock] = useState<stockModel | null>(null);

  const MobileStockCard = ({ stock }: { stock: stockModel }) => {
    const rawAvailable = Number(stock.OnHand) - stock.Quantity - stock.Delivery;
    const pieces = rawAvailable < 0 ? 0 : rawAvailable;
    const cartons = stock.PerCtns ? pieces / stock.PerCtns : 0;
    const pallets = stock.PerCtns && stock.PerPallet ? Math.round(pieces / stock.PerCtns / stock.PerPallet) : 0;

    return (
      <TouchableOpacity
        style={cardStyles.card}
        onPress={() => navigateToReportDetails(stock)}
        activeOpacity={0.7}
      >
        {/* Header */}
        <RNView style={cardStyles.cardHeader}>
          <RNView style={cardStyles.cardHeaderLeft}>
            <RNView style={cardStyles.containerIconWrap}>
              <Ionicons name="cube-outline" size={18} color={isDark ? colors.primary : "#3B82F6"} />
            </RNView>
            <RNView style={{ flex: 1, backgroundColor: "transparent" }}>
              <Text style={cardStyles.containerNumber}>{stock.ItemName}</Text>
            </RNView>
          </RNView>
        </RNView>

        <View style={cardStyles.divider} />

        {/* Quantities (Timeline style) */}
        {/* Quantities (Timeline style) */}
        <View style={cardStyles.dateRow}>
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("pieces") ? t("pieces").toUpperCase() : "PIECES"}</Text>
            <Text style={cardStyles.dateValue}>{Number(pieces).toLocaleString("en-US")}</Text>
          </View>
          <View style={{ width: 1, height: 24, backgroundColor: isDark ? colors.border : "#E2E8F0" }} />
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("cartons") ? t("cartons").toUpperCase() : "CARTONS"}</Text>
            <Text style={cardStyles.dateValue}>{Number(cartons.toFixed(2)).toLocaleString("en-US")}</Text>
          </View>
          <View style={{ width: 1, height: 24, backgroundColor: isDark ? colors.border : "#E2E8F0" }} />
          <View style={cardStyles.dateBlock}>
            <Text style={cardStyles.dateLabel}>{t("pallets") ? t("pallets").toUpperCase() : "PALLETS"}</Text>
            <Text style={cardStyles.dateValue}>{Number(pallets).toLocaleString("en-US")}</Text>
          </View>
        </View>

        <View style={cardStyles.divider} />

        {/* Footer info */}
        <View style={cardStyles.cardFooter}>
          <View style={cardStyles.metaChip}>
            <Ionicons name="pricetag-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
            <Text style={cardStyles.metaChipText}>{stock.ItemCode}</Text>
          </View>
          <View style={cardStyles.metaChip}>
            <Ionicons name="location-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
            <Text style={cardStyles.metaChipText}>{stock.Location}</Text>
          </View>
          <View style={cardStyles.metaChip}>
            <Ionicons name="business-outline" size={12} color={isDark ? colors.textSecondary : "#64748B"} />
            <Text style={cardStyles.metaChipText} numberOfLines={1} ellipsizeMode="tail">{stock.CardName}</Text>
          </View>
          {Number(stock.OrderReserved) > 0 && (
            <TouchableOpacity 
              style={[cardStyles.metaChip, { borderColor: colors.warning }]}
              onPress={(e) => {
                e.stopPropagation();
                setSelectedReservedStock(stock);
                setReservedModalVisible(true);
              }}
            >
              <Ionicons name="alert-circle-outline" size={12} color={colors.warning} />
              <Text style={[cardStyles.metaChipText, { color: colors.warning }]}>
                Reserved: {Number(stock.OrderReserved).toLocaleString("en-US")}
              </Text>
            </TouchableOpacity>
          )}
        </View>
      </TouchableOpacity>
    );
  };

  // Column visibility settings
  const [columnSettingsOpen, setColumnSettingsOpen] = useState<boolean>(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [columnOrder, setColumnOrder] = useState<string[]>([]);
  const [settingsBtnPos, setSettingsBtnPos] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const settingsBtnRef = useRef<any>(null);

  // Load saved hidden columns and column order from storage on mount
  useEffect(() => {
    AsyncStorage.getItem("stocks_hidden_columns").then((stored) => {
      if (stored) {
        try {
          setHiddenColumns(JSON.parse(stored));
        } catch { }
      }
    });
    AsyncStorage.getItem("stocks_column_order").then((stored) => {
      if (stored) {
        try {
          setColumnOrder(JSON.parse(stored));
        } catch { }
      }
    });
  }, []);

  useEffect(() => {
    navigation.setOptions({ title: t("stock") });
  }, [navigation, language, t]);

  // All available column (full set based on screen size)
  const getAllStockHeaders = () => {
    const base = isLargeDevice
      ? headersStock
      : isMobileDevice
        ? smStock
        : mdStock;
    return translateHeaders(base, t, stockReportTranslationMap);
  };

  const getOrderedKeys = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const allKeys = Object.keys(baseHeaders);
    if (columnOrder.length === 0) return allKeys;
    const ordered: string[] = [];
    columnOrder.forEach((k) => {
      if (allKeys.includes(k)) ordered.push(k);
    });
    allKeys.forEach((k) => {
      if (!ordered.includes(k)) ordered.push(k);
    });
    return ordered;
  };

  const getFilteredHeaders = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const orderedKeys = getOrderedKeys(baseHeaders);
    const visibleEntries = orderedKeys
      .filter((key) => !hiddenColumns.includes(key))
      .map(
        (key) =>
          [key, baseHeaders[key]] as [
            string,
            Record<string, string | number | boolean>,
          ],
      );
    const totalOriginalFlex = Object.values(baseHeaders).reduce(
      (sum, h) => sum + (Number(h.width) || 0),
      0,
    );
    const totalVisibleFlex = visibleEntries.reduce(
      (sum, [, h]) => sum + (Number(h.width) || 0),
      0,
    );
    const scale =
      totalVisibleFlex > 0 ? totalOriginalFlex / totalVisibleFlex : 1;

    const result: Record<
      string,
      Record<string, string | number | boolean>
    > = {};
    visibleEntries.forEach(([key, value]) => {
      result[key] = { ...value, width: Number(value.width) * scale };
    });
    return result;
  };

  // Update table headers when hidden columns or column order change (desktop only)
  useEffect(() => {
    if (isSmallDevice || isMobileDevice) return;
    const allHeaders = getAllStockHeaders();
    setTableHeaders(getFilteredHeaders(allHeaders));
  }, [hiddenColumns, columnOrder, isLargeDevice, isMediumDevice, language]);

  const toggleColumn = (columnKey: string) => {
    setHiddenColumns((prev) => {
      const updated = prev.includes(columnKey)
        ? prev.filter((k) => k !== columnKey)
        : [...prev, columnKey];
      AsyncStorage.setItem("stocks_hidden_columns", JSON.stringify(updated));
      return updated;
    });
  };

  const getOrderReservedLookupKey = (itemCode: string, warehouseCode: string) =>
    `${itemCode}_${warehouseCode}`;

  const getOrderReservedItems = (stock: stockModel) => {
    const itemCode =
      typeof stock.ItemCode === "string" ? stock.ItemCode : stock.ItemCode[0];
    const warehouseCode = stock.Whscode || (stock as any).WhsCode || "";

    return (
      orderReservedLookup[getOrderReservedLookupKey(itemCode, warehouseCode)] ||
      []
    );
  };

  const displayOrderReservedDetailsByCarton = (
    orderReservedDetails: Array<reserveStockModel>,
  ) => {
    return orderReservedDetails.map((reserveStock: reserveStockModel) => ({
      ...reserveStock,
      "Open Qty PCS":
        Number(reserveStock["Open Qty PCS"]) /
        (Number(reserveStock.PerCtns) || 1),
    }));
  };

  const getDisplayedOrderReservedDetails = (
    stock: stockModel,
    isDisplayByCarton: boolean,
  ) => {
    const orderReservedDetails = getOrderReservedItems(stock);

    return isDisplayByCarton
      ? displayOrderReservedDetailsByCarton(orderReservedDetails)
      : orderReservedDetails.map((reserveStock: reserveStockModel) => ({
        ...reserveStock,
      }));
  };

  const moveColumn = useCallback(
    (fromKey: string, toKey: string) => {
      const allHeaders = getAllStockHeaders();
      const currentKeys = getOrderedKeys(allHeaders).filter((k) => k !== "");
      const fromIdx = currentKeys.indexOf(fromKey);
      const toIdx = currentKeys.indexOf(toKey);
      if (fromIdx < 0 || toIdx < 0 || fromIdx === toIdx) return;
      const newKeys = [...currentKeys];
      newKeys.splice(fromIdx, 1);
      newKeys.splice(toIdx, 0, fromKey);
      newKeys.push("");
      setColumnOrder(newKeys);
      AsyncStorage.setItem("stocks_column_order", JSON.stringify(newKeys));
    },
    [columnOrder],
  );

  const resetColumnOrder = () => {
    setColumnOrder([]);
    AsyncStorage.removeItem("stocks_column_order");
  };

  const [dragActiveKey, setDragActiveKey] = useState<string | null>(null);
  const [dragOverKey, setDragOverKey] = useState<string | null>(null);
  const dragRef = useRef<{ activeKey: string | null; overKey: string | null }>({
    activeKey: null,
    overKey: null,
  });

  const startColumnDrag = useCallback(
    (key: string) => {
      if (Platform.OS !== "web" || typeof window === "undefined") return;
      dragRef.current.activeKey = key;
      setDragActiveKey(key);

      const onMouseMove = (e: MouseEvent) => {
        const el = document.elementFromPoint(e.clientX, e.clientY);
        const row =
          el && (el as HTMLElement).closest
            ? (el as HTMLElement).closest("[data-columnkey]")
            : null;
        const overKey = row ? row.getAttribute("data-columnkey") : null;
        if (overKey !== dragRef.current.overKey) {
          dragRef.current.overKey = overKey;
          setDragOverKey(
            overKey && overKey !== dragRef.current.activeKey ? overKey : null,
          );
        }
      };

      const onMouseUp = () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        document.body.style.cursor = "";
        (document.body.style as any).userSelect = "";
        const from = dragRef.current.activeKey;
        const to = dragRef.current.overKey;
        if (from && to && from !== to) {
          moveColumn(from, to);
        }
        dragRef.current = { activeKey: null, overKey: null };
        setDragActiveKey(null);
        setDragOverKey(null);
      };

      document.body.style.cursor = "grabbing";
      (document.body.style as any).userSelect = "none";
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    },
    [moveColumn],
  );

  const displayTableLoader = () => {
    handleTableLoader(true, false, setIsSearched);
  };

  const fadeTableLoader = () => {
    handleTableLoader(false, true, setIsSearched);
  };

  const handleScroll = (event: any) => {
    setContentOffSet(event.nativeEvent.contentOffset.y);
  };

  const onHandleSortColumn = (columnKey: string) => {
    const _sortedStocksReportList: Array<stockModel> = sortColumns(
      stocksPageLevelList,
      columnKey,
      tableHeaders,
      setTableHeaders,
    );

    setStocksPageLevelList(_sortedStocksReportList);
  };

  const searchableKeys = [
    "ItemCode",
    "ItemName",
    "Location",
    "FrgnName",
    "CardName",
    "CardCode",
    "ItmsGrpCod",
  ];

  const handleSearch = (searchText: string) => {
    displayTableLoader();

    if (searchText.trim() !== "") {
      setSearchedText(searchText);

      const filteredListBasedOnSearchOrCondition: Array<stockModel> =
        filterBasedOnAnyKey(stockReportList, searchText, searchableKeys);

      const _filterStockByCategory = filterStockByCategory(
        filteredListBasedOnSearchOrCondition,
        _filterCategory,
        selectedCategories,
      );

      //filter based on tags or display switch
      setStocksPageLevelList(
        _isDisplayViewOn
          ? displayStockByCarton(_filterStockByCategory)
          : displayStockByPiece(_filterStockByCategory),
      );
    } else {
      setSearchedText("");
      const _filterStockByCategory = filterStockByCategory(
        stockReportList,
        _filterCategory,
        selectedCategories,
      );
      setStocksPageLevelList(
        _isDisplayViewOn
          ? displayStockByCarton(_filterStockByCategory)
          : displayStockByPiece(_filterStockByCategory),
      );
    }

    fadeTableLoader();
  };

  const filterStockByCategory = (
    _stocksReport: Array<stockModel>,
    _filterCategory: string,
    categoriesArr?: string[],
  ) => {
    const activeCategories =
      categoriesArr && categoriesArr.length > 0
        ? categoriesArr
        : _filterCategory !== "all"
          ? [_filterCategory]
          : [];
    if (activeCategories.length === 0) return _stocksReport;

    const matchesCategory = (stock: stockModel, cat: string): boolean => {
      switch (cat) {
        case "produce":
          return [101, 102, 103, 104, 106].includes(stock.ItmsGrpCod);
        case "berry":
          return stock.ItmsGrpCod === 100;
        case "meat":
          return stock.ItmsGrpCod === 110;
        case "meals":
          return [111, 116].includes(stock.ItmsGrpCod);
        case "salad":
          return stock.ItmsGrpCod === 107;
        case "bakery":
          return stock.ItmsGrpCod === 108;
        case "NSW":
          return stock.State[0] === "NSW";
        case "VIC":
          return stock.State[0] === "VIC";
        case "QLD":
          return stock.State[0] === "QLD";
        case "TAS":
          return stock.State[0] === "TAS";
        case "WA":
          return stock.State[0] === "WA";
        case "SA":
          return stock.State[0] === "SA";
        default:
          return true;
      }
    };

    return _stocksReport.filter((stock: stockModel) =>
      activeCategories.some((cat) => matchesCategory(stock, cat)),
    );
  };

  const getAvailableInPalletsForExcel = (_stocksReport: stockModel) => {
    const _available =
      Number(_stocksReport.OnHand) -
      _stocksReport.Quantity -
      _stocksReport.Delivery;
    return Math.round(
      _available / _stocksReport.PerCtns / _stocksReport.PerPallet,
    );
  };

  const displayStockByCarton = (_stocksReport: Array<stockModel>) => {
    return _stocksReport.map((stock: stockModel) => {
      const _available = Number(stock.OnHand) - stock.Quantity - stock.Delivery;
      const _availablePallet = Math.round(
        _available / stock.PerCtns / stock.PerPallet,
      );
      const _availableByCarton = Number(_available) / stock.PerCtns;
      const _orderReserved = Number(stock.OrderReserved) / stock.PerCtns;
      const _onWater = Number(stock.OnWater) / stock.PerCtns;
      const _onOrder = Number(stock.OnOrder2) / stock.PerCtns;
      const _inventoryTransferring =
        Number(stock["Inventory Transferring"]) / stock.PerCtns;
      const orderReservedDetails = getDisplayedOrderReservedDetails(
        stock,
        true,
      );
      return {
        ...stock,
        ItemCode:
          typeof stock.ItemCode === "string"
            ? stock.ItemCode
            : stock.ItemCode[0],
        ItemName:
          typeof stock.ItemName === "string"
            ? stock.ItemName
            : stock.ItemName[0],
        State: typeof stock.State === "string" ? stock.State : stock.State[0],
        AvaliablePallet:
          _availablePallet < 0 ? "0" : _availablePallet.toString(),
        Available2:
          _availableByCarton < 0 ? "0" : _availableByCarton.toString(),
        OrderReserved: _orderReserved < 0 ? 0 : _orderReserved,
        orderReservedDetails,
        OnWater: _onWater < 0 ? "0" : _onWater.toString(),
        OnOrder2: _onOrder < 0 ? "0" : _onOrder.toString(),
        "Inventory Transferring":
          _inventoryTransferring < 0 ? "0" : _inventoryTransferring.toString(),
      };
    });
  };

  const displayStockByPiece = (_stocksReport: Array<stockModel>) => {
    return _stocksReport.map((stock: stockModel) => {
      const _available = Number(stock.OnHand) - stock.Quantity - stock.Delivery;
      const _availablePallet = Math.round(
        _available / stock.PerCtns / stock.PerPallet,
      );
      const orderReservedDetails = getDisplayedOrderReservedDetails(
        stock,
        false,
      );
      return {
        ...stock,
        ItemCode: stock.ItemCode[0],
        ItemName: stock.ItemName[0],
        State: stock.State[0],
        AvaliablePallet:
          _availablePallet < 0 ? "0" : _availablePallet.toString(),
        Available2: _available < 0 ? "0" : _available.toString(),
        OrderReserved:
          Number(stock.OrderReserved) < 0 ? 0 : Number(stock.OrderReserved),
        orderReservedDetails,
        OnWater:
          Number(stock.OnWater) < 0 ? "0" : Number(stock.OnWater).toString(),
        OnOrder2:
          Number(stock.OnOrder2) < 0 ? "0" : Number(stock.OnOrder2).toString(),
        "Inventory Transferring":
          Number(stock["Inventory Transferring"]) < 0
            ? "0"
            : Number(stock["Inventory Transferring"]).toString(),
      };
    });
  };

  useEffect(() => {
    setImageLoading(true);
    setSelectedImage("");
  }, [modalVisible]);

  useEffect(() => {
    if (selected?.PicturName) {
      validSignedURLWithExt(
        selected.PicturName || "",
        "label",
        setImageLoading,
        setSelectedImage,
      );
    } else {
      getS3SignUrl("multisteps-label", "no-image.png", "getObject", "image/*").then(
        (data) => {
          setSelectedImage(data?.signedUrl as string);
          setImageLoading(false);
        },
      );
    }
  }, [selected]);

  useEffect(() => {
    const lookup: Record<string, Array<reserveStockModel>> = {};

    (reserveStockReport as Array<reserveStockModel>).forEach((reserveStock) => {
      const lookupKey = getOrderReservedLookupKey(
        reserveStock.ItemCode,
        reserveStock.WhsCode,
      );

      if (!lookup[lookupKey]) {
        lookup[lookupKey] = [];
      }

      lookup[lookupKey].push(reserveStock);
    });

    setOrderReservedLookup(lookup);
  }, [reserveStockReport]);

  useEffect(() => {
    setLastRefresh(lastRefreshStockReport);
  }, [lastRefreshStockReport]);

  useEffect(() => {
    if (isSmallDevice || isMobileDevice) {
      setTableHeaders(getAllStockHeaders());
    } else {
      setTableHeaders(getFilteredHeaders(getAllStockHeaders()));
    }
  }, [isLargeDevice, isMediumDevice, hiddenColumns, columnOrder]);

  useEffect(() => {
    let isMounted: boolean = true;
    const _userInfo = userInfo as userClaimInformation;

    if (isMounted) {
      //To restrict fetching data from endpoint, if data is available in store
      if (stocksPageLevelList.length === 0 || isRefresh) {
        displayTableLoader();

        //set filtering by category & display by carton to default
        _setIsDisplayViewOn(false);
        _setFilterCategory("all");
        setSearchedText("");

        //set last refresh date
        const formattedLastRefreshDate = formatDate(new Date(), "short", true);
        ReportsDispatcher(
          actionTypesReports.LastRefreshStockReport,
          formattedLastRefreshDate,
        );

        getStocks(_userInfo.team, _userInfo.zone_info, tableHeaders);

        if (!isReserveStockReportListLoaded || isRefresh) {
          getReserveStocks(headersReserveStock);
        }

        fadeTableLoader();
      }
    }

    const baseHeaders = translateHeaders(
      isLargeDevice ? headersStock : isMobileDevice ? smStock : mdStock,
      t,
      stockReportTranslationMap,
    );
    setTableHeaders(
      isSmallDevice || isMobileDevice
        ? baseHeaders
        : getFilteredHeaders(baseHeaders),
    );

    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [isFocused, isRefresh]);

  useEffect(() => {
    displayTableLoader();

    const _stocksReport = _isDisplayViewOn
      ? stocksPageLevelList
      : (stockReportList as Array<stockModel>);
    const filteredListBasedOnSearchOrCondition =
      searchedText.trim().length > 0
        ? filterBasedOnAnyKey(_stocksReport, searchedText, searchableKeys)
        : _stocksReport;

    if (_isDisplayViewOn) {
      setStocksPageLevelList(
        displayStockByCarton(filteredListBasedOnSearchOrCondition),
      );
    } else {
      setStocksPageLevelList(
        filterStockByCategory(
          displayStockByPiece(filteredListBasedOnSearchOrCondition),
          _filterCategory,
          selectedCategories,
        ),
      );
    }

    fadeTableLoader();
  }, [_isDisplayViewOn, orderReservedLookup]);

  useEffect(() => {
    displayTableLoader();

    const _stocksReport = stockReportList as Array<stockModel>;
    const filteredListBasedOnSearchOrCondition =
      searchedText.trim().length > 0
        ? filterBasedOnAnyKey(_stocksReport, searchedText, searchableKeys)
        : _stocksReport;

    if (_isDisplayViewOn) {
      setStocksPageLevelList(
        displayStockByCarton(
          filterStockByCategory(
            filteredListBasedOnSearchOrCondition,
            _filterCategory,
            selectedCategories,
          ),
        ),
      );
    } else {
      setStocksPageLevelList(
        displayStockByPiece(
          filterStockByCategory(
            filteredListBasedOnSearchOrCondition,
            _filterCategory,
            selectedCategories,
          ),
        ),
      );
    }

    fadeTableLoader();
  }, [_filterCategory, selectedCategories, orderReservedLookup]);

  const formatThousandSepeartorForExport = (value: string | number) =>
    value !== null && value !== undefined
      ? Number(value).toLocaleString("en-US")
      : "";

  useEffect(() => {
    displayTableLoader();

    const _stocksReport = stockReportList as Array<stockModel>;
    const filteredListBasedOnSearchOrCondition =
      searchedText.trim().length > 0
        ? filterBasedOnAnyKey(_stocksReport, searchedText, searchableKeys)
        : _stocksReport;

    if (_filterCategory === "all" && !_isDisplayViewOn) {
      setStocksPageLevelList(
        displayStockByPiece(filteredListBasedOnSearchOrCondition),
      );
    }

    fadeTableLoader();
  }, [
    stockReportList,
    _isDisplayViewOn,
    _filterCategory === "all" && selectedCategories.length === 0,
    orderReservedLookup,
  ]);

  const navigateToReportDetails = (order: any, action: string) => {
    navigation.navigate("StockReportDetailsReportScreen", { order });
  };

  const ModalContent = (props: any) => {
    return (
      <Modal.ModalContent
        {...props}
        title={selected.ItemCode || ""}
        subTitle={selected.FrgnName || ""}
        icon="folder"
        uri={selectedImage}
        loading={isImageLoading}
        childern={
          <StockDetailsModalBody order={selected} isDisplayViewOn={_isDisplayViewOn} />
        }
      />
    );
  };

  const ReservedModalContent = (props: any) => {
    return (
      <Modal.ModalContent
        {...props}
        title="Reserved Details"
        subTitle={selectedReservedStock?.ItemName || ""}
        icon="folder"
        childern={
          <ScrollView style={{ padding: 16, maxHeight: 500 }}>
            {selectedReservedStock?.orderReservedDetails?.map((detail, idx) => (
              <View key={idx} style={{ marginBottom: 16, borderBottomWidth: 1, borderBottomColor: isDark ? colors.border : "#E2E8F0", paddingBottom: 16 }}>
                <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                  <View style={{ flex: 1, marginRight: 8 }}>
                    <Text style={{ fontSize: 14, fontWeight: "600", color: isDark ? colors.text : "#1E293B" }}>
                      {detail.CardName}
                    </Text>
                    <Text style={{ fontSize: 12, color: isDark ? colors.textSecondary : "#64748B", marginTop: 4 }}>
                      #{detail.DocNum}
                    </Text>
                  </View>
                  <View style={{ alignItems: "flex-end" }}>
                    <Text style={{ fontSize: 14, fontWeight: "bold", color: colors.warning }}>
                      {Number(detail["Open Qty PCS"]).toLocaleString("en-US")} {_isDisplayViewOn ? "CTNS" : "PCS"}
                    </Text>
                    <View style={{ backgroundColor: isDark ? colors.surface : "#F1F5F9", paddingHorizontal: 6, paddingVertical: 2, borderRadius: 4, marginTop: 4 }}>
                      <Text style={{ fontSize: 10, color: isDark ? colors.textSecondary : "#64748B", textTransform: "uppercase", fontWeight: "600" }}>
                        {detail["Doc Status"] || "Unknown"}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Additional Details Grid */}
                <View style={{ backgroundColor: isDark ? colors.surface : "#F8FAFC", padding: 12, borderRadius: 8 }}>
                  <View style={{ flexDirection: "row", marginBottom: 12 }}>
                    <View style={{ flex: 1, paddingRight: 8 }}>
                      <Text style={{ fontSize: 10, color: isDark ? colors.textSecondary : "#94A3B8", textTransform: "uppercase", fontWeight: "500" }}>Order Date</Text>
                      <Text style={{ fontSize: 12, color: isDark ? colors.text : "#334155", marginTop: 2 }}>{detail["Order Date"] ? formatDate(detail["Order Date"]) : "-"}</Text>
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text style={{ fontSize: 10, color: isDark ? colors.textSecondary : "#94A3B8", textTransform: "uppercase", fontWeight: "500" }}>Valid Until</Text>
                      <Text style={{ fontSize: 12, color: isDark ? colors.text : "#334155", marginTop: 2 }}>{detail["Valid until"] ? formatDate(detail["Valid until"]) : "-"}</Text>
                    </View>
                  </View>
                  
                  <View style={{ flexDirection: "row", marginBottom: 12 }}>
                    <View style={{ flex: 1 }}>
                      <Text style={{ fontSize: 10, color: isDark ? colors.textSecondary : "#94A3B8", textTransform: "uppercase", fontWeight: "500" }}>Sales Rep</Text>
                      <Text style={{ fontSize: 12, color: isDark ? colors.text : "#334155", marginTop: 2 }}>{detail.SlpName || "-"}</Text>
                    </View>
                  </View>

                  <View style={{ flexDirection: "column" }}>
                    <Text style={{ fontSize: 10, color: isDark ? colors.textSecondary : "#94A3B8", textTransform: "uppercase", fontWeight: "500" }}>Address</Text>
                    <Text style={{ fontSize: 12, color: isDark ? colors.text : "#334155", marginTop: 2, lineHeight: 18 }}>
                      {detail.Address2?.trim() || "-"}
                    </Text>
                  </View>
                </View>
              </View>
            ))}
          </ScrollView>
        }
      />
    );
  };

  return (
    <View style={{ flex: 1, backgroundColor: isDark ? colors.background : "#f1f5f9" }}>
      <ScrollView
        scrollEventThrottle={16}
        style={{ flex: 1, backgroundColor: isDark ? colors.background : "#f1f5f9" }}
        contentContainerStyle={{ flexGrow: 1 }}
        onScroll={handleScroll}
        ref={listRef}
      >
        <View
          style={[
            styles.pageWrapper,
            { backgroundColor: isDark ? colors.background : "#f1f5f9" },
          ]}
        >
          {isStockReportListLoaded ? (
            <>
              <View style={[cardStyles.tableCard, !isSmallDevice && { marginTop: 12 }, isSmallDevice && { marginBottom: 8 }]}>
                <LabelBannerWithSearchBar
                  titleName={`${t("totalItems")}: ${stocksPageLevelList.length}`}
                  handleSearch={handleSearch}
                  setRefresh={setRefresh}
                  middleSearchControls={
                    (isSmallDevice || isMobileDevice) ? (
                      <TouchableOpacity
                        style={[
                          {
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            backgroundColor: showMobileFilters ? colors.primary : colors.surfaceSubtle,
                            justifyContent: "center",
                            alignItems: "center",
                            borderWidth: 1,
                            borderColor: showMobileFilters ? colors.primary : colors.border,
                          },
                          (isSmallDevice || isMobileDevice) && {
                            width: 34,
                            height: 34,
                            borderRadius: 8,
                          }
                        ]}
                        onPress={() => setShowMobileFilters(!showMobileFilters)}
                      >
                        <Feather
                          name="filter"
                          size={(isSmallDevice || isMobileDevice) ? 14 : 15}
                          color={showMobileFilters ? "#FFFFFF" : "#6B7280"}
                        />
                      </TouchableOpacity>
                    ) : undefined
                  }
                  dataToExport={stocksPageLevelList.map((stock) => {
                    const availableInPallets =
                      getAvailableInPalletsForExcel(stock);

                    return {
                      [t("itemCode")]: stock.ItemCode,
                      [t("itemName")]: stock.ItemName,
                      [t("itemDescription")]: stock.FrgnName,
                      [t("pcsCarton")]: Number(stock.PerCtns),
                      [t("ctnsPerPallet")]: Number(stock.PerPallet),
                      State: stock.State,
                      [t("location")]: stock.Location,
                      [t("customerName")]: stock.CardName,
                      CardCode: stock.CardCode,
                      [t("available")]: Number(stock.Available2),
                      [t("orderReserved")]: Number(stock.OrderReserved),
                      [t("availablePallet")]: availableInPallets,
                      [t("inTransit")]: Number(stock.OnWater),
                      [t("onOrder")]: Number(stock.OnOrder2),
                      [t("transferringIn")]: Number(
                        stock["Inventory Transferring"],
                      ),
                    };
                  })}
                  fileName="stockReportScreen"
                  sheetName="Stock Report Screen"
                  preSearchControls={
                    !(isSmallDevice || isMobileDevice) ? (
                      <RNView>
                        <TouchableOpacity
                          ref={settingsBtnRef}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            backgroundColor: columnSettingsOpen
                              ? colors.primary + "1A"
                              : colors.surfaceSubtle,
                            justifyContent: "center",
                            alignItems: "center",
                            borderWidth: 1,
                            borderColor: columnSettingsOpen
                              ? colors.primary
                              : colors.border,
                          }}
                          onPress={() => {
                            if (settingsBtnRef.current) {
                              settingsBtnRef.current.measureInWindow(
                                (
                                  x: number,
                                  y: number,
                                  width: number,
                                  height: number,
                                ) => {
                                  setSettingsBtnPos({ x, y, width, height });
                                  setColumnSettingsOpen(!columnSettingsOpen);
                                },
                              );
                            } else {
                              setColumnSettingsOpen(!columnSettingsOpen);
                            }
                          }}
                        >
                          <Feather
                            name="settings"
                            size={15}
                            color={columnSettingsOpen ? colors.primary : colors.textSecondary}
                          />
                        </TouchableOpacity>
                        {columnSettingsOpen && (
                          <RNModal
                            transparent={true}
                            visible={columnSettingsOpen}
                            animationType="fade"
                            onRequestClose={() => setColumnSettingsOpen(false)}
                          >
                            <Pressable
                              style={{
                                flex: 1,
                                backgroundColor: "rgba(0,0,0,0.15)",
                              }}
                              onPress={() => setColumnSettingsOpen(false)}
                            >
                              <Pressable
                                style={{
                                  position: "absolute",
                                  top:
                                    settingsBtnPos.y + settingsBtnPos.height + 6,
                                  left: settingsBtnPos.x - 180 + 40,
                                  backgroundColor: colors.surface,
                                  borderRadius: 12,
                                  borderWidth: 1,
                                  borderColor: colors.border,
                                  paddingVertical: 10,
                                  minWidth: 220,
                                  shadowColor: "#000",
                                  shadowOffset: { width: 0, height: 8 },
                                  shadowOpacity: 0.15,
                                  shadowRadius: 20,
                                  elevation: 10,
                                }}
                                onPress={(e) => e.stopPropagation()}
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontWeight: "700",
                                    color: colors.textSecondary,
                                    paddingHorizontal: 16,
                                    paddingBottom: 8,
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  {t("showHideColumns")}
                                </Text>
                                <View
                                  style={{
                                    height: 1,
                                    backgroundColor: colors.borderSubtle,
                                    marginBottom: 4,
                                  }}
                                />
                                {/* Select All */}
                                <TouchableOpacity
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                  }}
                                  onPress={() => {
                                    const allKeys = Object.keys(
                                      getAllStockHeaders(),
                                    ).filter((k) => k !== "");
                                    if (hiddenColumns.length === 0) {
                                      const updated = [...allKeys];
                                      setHiddenColumns(updated);
                                      AsyncStorage.setItem(
                                        "stocks_hidden_columns",
                                        JSON.stringify(updated),
                                      );
                                    } else {
                                      setHiddenColumns([]);
                                      AsyncStorage.setItem(
                                        "stocks_hidden_columns",
                                        JSON.stringify([]),
                                      );
                                    }
                                  }}
                                >
                                  <View
                                    style={{
                                      width: 20,
                                      height: 20,
                                      borderRadius: 4,
                                      borderWidth: 1.5,
                                      borderColor:
                                        hiddenColumns.length === 0
                                          ? colors.primary
                                          : colors.textMuted,
                                      backgroundColor:
                                        hiddenColumns.length === 0
                                          ? colors.primary
                                          : colors.surface,
                                      justifyContent: "center",
                                      alignItems: "center",
                                      marginRight: 10,
                                    }}
                                  >
                                    {hiddenColumns.length === 0 && (
                                      <Feather
                                        name="check"
                                        size={13}
                                        color="#fff"
                                      />
                                    )}
                                  </View>
                                  <Text
                                    style={{
                                      fontSize: 14,
                                      color: colors.text,
                                      fontWeight: "700",
                                    }}
                                  >
                                    {t("selectAll")}
                                  </Text>
                                </TouchableOpacity>
                                <View
                                  style={{
                                    height: 1,
                                    backgroundColor: colors.borderSubtle,
                                    marginBottom: 2,
                                  }}
                                />
                                <ScrollView
                                  style={{ maxHeight: 300 }}
                                  showsVerticalScrollIndicator={true}
                                >
                                  {getOrderedKeys(getAllStockHeaders()).map(
                                    (key) => {
                                      if (key === "") return null;
                                      const value = getAllStockHeaders()[key];
                                      if (!value) return null;
                                      const isVisible =
                                        !hiddenColumns.includes(key);
                                      const isDragging = dragActiveKey === key;
                                      const isDragOver = dragOverKey === key;
                                      return (
                                        <RNView
                                          key={key}
                                          {...({
                                            dataSet: { columnkey: key },
                                          } as any)}
                                          style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            paddingVertical: 8,
                                            paddingHorizontal: 16,
                                            opacity: isDragging ? 0.35 : 1,
                                            backgroundColor: isDragOver
                                              ? colors.primary + "1A"
                                              : "transparent",
                                            borderTopWidth: isDragOver ? 2 : 0,
                                            borderTopColor: colors.primary,
                                          }}
                                        >
                                          <Pressable
                                            onPressIn={() => startColumnDrag(key)}
                                            style={
                                              {
                                                padding: 4,
                                                marginRight: 6,
                                                cursor: "grab",
                                              } as any
                                            }
                                          >
                                            <Feather
                                              name="menu"
                                              size={14}
                                              color="#9CA3AF"
                                            />
                                          </Pressable>
                                          <TouchableOpacity
                                            style={{
                                              flexDirection: "row",
                                              alignItems: "center",
                                              flex: 1,
                                            }}
                                            onPress={() => toggleColumn(key)}
                                          >
                                            <RNView
                                              style={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: 4,
                                                borderWidth: 1.5,
                                                borderColor: isVisible
                                                  ? colors.primary
                                                  : colors.textMuted,
                                                backgroundColor: isVisible
                                                  ? colors.primary
                                                  : colors.surface,
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginRight: 10,
                                              }}
                                            >
                                              {isVisible && (
                                                <Feather
                                                  name="check"
                                                  size={13}
                                                  color="#fff"
                                                />
                                              )}
                                            </RNView>
                                            <Text
                                              style={{
                                                fontSize: 14,
                                                color: isVisible
                                                  ? colors.text
                                                  : colors.textMuted,
                                                fontWeight: isVisible
                                                  ? "600"
                                                  : "400",
                                              }}
                                            >
                                              {((value as any).name || "").replace(/\n/g, " ")}
                                            </Text>
                                          </TouchableOpacity>
                                        </RNView>
                                      );
                                    },
                                  )}
                                </ScrollView>
                                {columnOrder.length > 0 && (
                                  <>
                                    <RNView
                                      style={{
                                        height: 1,
                                        backgroundColor: colors.borderSubtle,
                                        marginTop: 4,
                                      }}
                                    />
                                    <TouchableOpacity
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        paddingVertical: 10,
                                        paddingHorizontal: 16,
                                      }}
                                      onPress={resetColumnOrder}
                                    >
                                      <Feather
                                        name="rotate-ccw"
                                        size={13}
                                        color="#6B7280"
                                      />
                                      <Text
                                        style={{
                                          fontSize: 13,
                                          color: colors.textSecondary,
                                          fontWeight: "600",
                                          marginLeft: 6,
                                        }}
                                      >
                                        {t("resetOrder")}
                                      </Text>
                                    </TouchableOpacity>
                                  </>
                                )}
                              </Pressable>
                            </Pressable>
                          </RNModal>
                        )}
                      </RNView>
                    ) : undefined
                  }
                />

                {((isSmallDevice || isMobileDevice) ? showMobileFilters : true) && (
                  <View style={stockFilterStyles.renderFilterStyles}>
                    {isSmallDevice || isMobileDevice ? (
                      <View style={stockFilterStyles.mobileFilterWrapper}>
                      <ScrollView
                        horizontal
                        showsHorizontalScrollIndicator={false}
                      >
                        {/* Products Dropdown */}
                        <TouchableOpacity
                          style={[
                            stockFilterStyles.mobileDropdownButton,
                            { marginRight: 8 },
                            mobileFilterMenu === "product" && stockFilterStyles.mobileDropdownButtonActive,
                          ]}
                          onPress={() => setMobileFilterMenu(mobileFilterMenu === "product" ? null : "product")}
                        >
                          <Text style={stockFilterStyles.mobileDropdownLabel}>
                            {t("products") ? t("products") : "Products"}:{" "}
                          </Text>
                          <Text style={stockFilterStyles.mobileDropdownValue}>
                            {(() => {
                              const selectedProducts = selectedCategories.filter(c => productCategories.includes(c));
                              return selectedProducts.length === 0
                                ? t("all")
                                : selectedProducts.length === 1
                                  ? renameLabel(selectedProducts[0])
                                  : `${selectedProducts.length} ${t("selected")}`;
                            })()}
                          </Text>
                          <Text style={stockFilterStyles.mobileDropdownArrow}>
                            {mobileFilterMenu === "product" ? "▲" : "▼"}
                          </Text>
                        </TouchableOpacity>

                        {/* States Dropdown */}
                        <TouchableOpacity
                          style={[
                            stockFilterStyles.mobileDropdownButton,
                            mobileFilterMenu === "state" && stockFilterStyles.mobileDropdownButtonActive,
                          ]}
                          onPress={() => setMobileFilterMenu(mobileFilterMenu === "state" ? null : "state")}
                        >
                          <Text style={stockFilterStyles.mobileDropdownLabel}>
                            {t("states") ? t("states") : "States"}:{" "}
                          </Text>
                          <Text style={stockFilterStyles.mobileDropdownValue}>
                            {(() => {
                              const selectedStates = selectedCategories.filter(c => stateCategories.includes(c));
                              return selectedStates.length === 0
                                ? t("all")
                                : selectedStates.length === 1
                                  ? renameLabel(selectedStates[0])
                                  : `${selectedStates.length} ${t("selected")}`;
                            })()}
                          </Text>
                          <Text style={stockFilterStyles.mobileDropdownArrow}>
                            {mobileFilterMenu === "state" ? "▲" : "▼"}
                          </Text>
                        </TouchableOpacity>
                      </ScrollView>

                      {mobileFilterMenu !== null && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={stockFilterStyles.mobileChipRow}
                        >
                          {["all", ...(mobileFilterMenu === "product" ? productCategories : stateCategories)].map(
                            (category: string, index: number) => {
                              const isProductMenu = mobileFilterMenu === "product";
                              const activeSet = isProductMenu ? productCategories : stateCategories;
                              const selectedInActiveSet = selectedCategories.filter(c => activeSet.includes(c));
                              const isActive =
                                category === "all"
                                  ? selectedInActiveSet.length === 0
                                  : selectedCategories.includes(category);

                              return (
                                <TouchableOpacity
                                  key={index}
                                  style={[
                                    stockFilterStyles.filterButton,
                                    isActive && stockFilterStyles.activeFilterButton,
                                  ]}
                                  onPress={() => {
                                    if (category === "all") {
                                      // Remove all from current active set
                                      const newCats = selectedCategories.filter(c => !activeSet.includes(c));
                                      setSelectedCategories(newCats);
                                      _setFilterCategory(newCats.length === 0 ? "all" : newCats.join(","));
                                    } else {
                                      const newCats = selectedCategories.includes(category)
                                        ? selectedCategories.filter((c) => c !== category)
                                        : [...selectedCategories, category];
                                      setSelectedCategories(newCats);
                                      _setFilterCategory(newCats.length === 0 ? "all" : newCats.join(","));
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? stockFilterStyles.activeFilterText
                                        : stockFilterStyles.filterText
                                    }
                                  >
                                    {renameLabel(category)}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}
                    </View>
                    ) : (
                    <ScrollView
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      contentContainerStyle={stockFilterStyles.filterContainer}
                    >
                      <Text style={stockFilterStyles.quickFilterText}>
                        {t("quickFilter")}
                      </Text>
                      {stockReportFilterCategoryList.map(
                        (category: string, index: number) => {
                          const isActive =
                            category === "all"
                              ? selectedCategories.length === 0
                              : selectedCategories.includes(category);
                          return (
                            <TouchableOpacity
                              key={index}
                              style={[
                                stockFilterStyles.filterButton,
                                isActive && stockFilterStyles.activeFilterButton,
                              ]}
                              onPress={() => {
                                if (category === "all") {
                                  setSelectedCategories([]);
                                  _setFilterCategory("all");
                                } else {
                                  const newCats = selectedCategories.includes(
                                    category,
                                  )
                                    ? selectedCategories.filter(
                                      (c) => c !== category,
                                    )
                                    : [...selectedCategories, category];
                                  setSelectedCategories(newCats);
                                  _setFilterCategory(
                                    newCats.length === 0
                                      ? "all"
                                      : newCats.join(","),
                                  );
                                }
                              }}
                            >
                              <Text
                                style={
                                  isActive
                                    ? stockFilterStyles.activeFilterText
                                    : stockFilterStyles.filterText
                                }
                              >
                                {renameLabel(category)}
                              </Text>
                            </TouchableOpacity>
                          );
                        },
                      )}
                    </ScrollView>
                  )}

                  {!(isSmallDevice || isMobileDevice) && (
                    <StockReportDisplaySwitch
                      title={t("display")}
                      lastRefresh={lastRefresh}
                      isDisplayViewOn={_isDisplayViewOn}
                      setIsDisplayViewOn={_setIsDisplayViewOn}
                    />
                  )}
                </View>
                )}
                {!isSmallDevice && (
                  <DataTableWithPagination
                    headers={tableHeaders}
                    rows={stocksPageLevelList}
                    itemsPerPage={20}
                    useModal={true}
                    isDataLoading={isSearched}
                    nestedHeader={inlineOrderReservedHeaders}
                    isRowsExpandable={true}
                    isNestedDataLoaded={!isReserveStockReportListLoaded}
                    setModalVisible={setModalVisible}
                    setSelected={setSelected}
                    rowKeyValue="Key"
                    nestedItemKeyValue="orderReservedDetails"
                    isDetail={true}
                    handleRowClick={() => { }}
                    handleDeleteRow={() => { }}
                    handleSortColumn={onHandleSortColumn}
                    columnsToNotHaveThousandSeparator={["Order Number"]}
                    selectable={true}
                    expandTriggerColumnKey="OrderReserved"
                    showExpandTrigger={(row) => Number(row.OrderReserved) > 0}
                    disableNestedRowActions={true}
                  />
                )}
              </View>

              {isSmallDevice && (
                <View style={cardStyles.cardList}>
                  {stocksPageLevelList.length === 0 ? (
                    <View style={cardStyles.emptyState}>
                      <Ionicons name="cube-outline" size={48} color="#CBD5E1" />
                      <Text style={cardStyles.emptyStateText}>{t("noDataAvailable")}</Text>
                    </View>
                  ) : (
                    <>
                      {stocksPageLevelList
                        .slice(mobilePage * itemsPerPage, (mobilePage + 1) * itemsPerPage)
                        .map((stock, index) => (
                          <MobileStockCard key={stock.Key || index} stock={stock} />
                        ))}
                      <ThemeProvider
                        theme={{ 
                          ...paperTheme,
                          dark: isDark,
                          colors: { 
                            ...paperTheme.colors,
                            text: isDark ? colors.text : "#0F172A",
                            onSurface: isDark ? colors.textSecondary : "#0F172A"
                          } 
                        }}
                      >
                        <DataTable.Pagination
                          page={mobilePage}
                          numberOfPages={Math.ceil(stocksPageLevelList.length / itemsPerPage)}
                          onPageChange={(page) => setMobilePage(page)}
                          label={`${mobilePage * itemsPerPage + 1}-${Math.min(
                            (mobilePage + 1) * itemsPerPage,
                            stocksPageLevelList.length
                          )} of ${stocksPageLevelList.length}`}
                          showFastPaginationControls
                        />
                      </ThemeProvider>
                    </>
                  )}
                </View>
              )}
            </>
          ) : (
            <View>
              <Spinner
                size="small"
                color="#74BBFF"
                styles={{ flexDirection: "row", margin: "20%" }}
              />
            </View>
          )}
        </View>
      </ScrollView>
      <Modal.ModalContainer
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        childern={ModalContent}
      />
      <Modal.ModalContainer
        modalVisible={reservedModalVisible}
        setModalVisible={setReservedModalVisible}
        childern={ReservedModalContent}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  pageWrapper: {
    flex: 1,
    minHeight: "100%" as any,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  fab: {
    position: "absolute",
    margin: 16,
    right: 0,
    zIndex: 1,
  },
});

const getStockFilterStyles = (colors: any) => StyleSheet.create({
  renderFilterStyles: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingBottom: 16,
    marginTop: 0,
  },
  filterContainer: {
    flexDirection: "row",
    paddingVertical: 0,
    paddingHorizontal: 15,
  },
  quickFilterText: {
    display: "flex",
    alignItems: "center",
    marginRight: 10,
    color: colors.text,
  },
  filterButton: {
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: colors.surfaceSubtle,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 999,
    marginRight: 8,
    marginBottom: 6,
  },
  activeFilterButton: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  filterText: {
    fontSize: 13,
    color: colors.textSecondary,
    fontWeight: "500",
  },
  activeFilterText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },
  mobileFilterWrapper: {
    flex: 1,
  },
  mobileDropdownButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: colors.surfaceSubtle,
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 999,
    alignSelf: "flex-start",
  },
  mobileDropdownButtonActive: {
    borderColor: colors.primary,
    backgroundColor: colors.primaryBg,
  },
  mobileDropdownLabel: {
    fontSize: 12,
    fontWeight: "600",
    color: colors.textSecondary,
    textTransform: "capitalize",
  },
  mobileDropdownValue: {
    fontSize: 12,
    fontWeight: "700",
    color: colors.primary,
  },
  mobileDropdownArrow: {
    fontSize: 8,
    color: colors.textSecondary,
    marginLeft: 4,
  },
  mobileChipRow: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 4,
  },
});

function createCardStyles(colors: any, isDark: boolean) {
  return StyleSheet.create({
    cardList: {
      paddingHorizontal: 16,
      paddingBottom: 24,
      paddingTop: 8,
      gap: 12,
      backgroundColor: "transparent",
    },
    tableCard: {
      marginHorizontal: 16,
      marginBottom: 24,
      marginTop: 12,
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 16,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E2E8F0",
      overflow: "hidden" as any,
      shadowColor: isDark ? colors.text : "#0F172A",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.07,
      shadowRadius: 12,
      elevation: 4,
    },
    card: {
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 16,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E8EDF5",
      shadowColor: isDark ? colors.text : "#1E293B",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.07,
      shadowRadius: 10,
      elevation: 3,
      overflow: "hidden" as any,
      marginBottom: 4,
    },
    cardHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 16,
      paddingVertical: 14,
      backgroundColor: isDark ? colors.surfaceSubtle : "#FAFBFF",
    },
    cardHeaderLeft: {
      flexDirection: "row",
      alignItems: "center",
      gap: 10,
      backgroundColor: "transparent",
      flex: 1,
      paddingRight: 10,
    },
    containerIconWrap: {
      width: 34,
      height: 34,
      borderRadius: 10,
      backgroundColor: isDark ? colors.primary + "33" : "#E1F0FA",
      alignItems: "center",
      justifyContent: "center",
    },
    containerNumber: {
      fontSize: 14,
      fontWeight: "700" as const,
      color: isDark ? colors.text : "#0F172A",
      letterSpacing: 0.2,
      flexWrap: "wrap",
      backgroundColor: "transparent",
    },
    statusBadge: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 5,
      paddingHorizontal: 10,
      borderRadius: 999,
      backgroundColor: isDark ? colors.surfaceSubtle : "#EFF6FF",
      gap: 5,
    },
    statusDot: {
      width: 7,
      height: 7,
      borderRadius: 999,
    },
    statusText: {
      fontSize: 12,
      fontWeight: "600" as const,
    },
    divider: {
      height: 1,
      backgroundColor: isDark ? colors.background : "#f1f5f9",
      marginHorizontal: 16,
    },
    dateRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 16,
      paddingVertical: 14,
      gap: 4,
    },
    dateBlock: {
      flex: 1,
      alignItems: "center",
      gap: 3,
    },
    dateLabel: {
      fontSize: 10,
      color: isDark ? colors.textSecondary : "#94A3B8",
      fontWeight: "600" as const,
      textTransform: "uppercase" as any,
      letterSpacing: 0.5,
    },
    dateValue: {
      fontSize: 13,
      color: isDark ? colors.text : "#1E293B",
      fontWeight: "700" as const,
    },
    cardFooter: {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap" as any,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderTopWidth: 1,
      borderTopColor: isDark ? colors.background : "#f1f5f9",
      backgroundColor: isDark ? colors.surfaceSubtle : "#FAFBFF",
      gap: 8,
    },
    metaChip: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: isDark ? colors.surface : "#FFFFFF",
      borderRadius: 6,
      paddingVertical: 4,
      paddingHorizontal: 8,
      gap: 4,
      borderWidth: 1,
      borderColor: isDark ? colors.border : "#E2E8F0",
      flexShrink: 1,
      maxWidth: "100%",
    },
    metaChipText: {
      fontSize: 11,
      color: isDark ? colors.textSecondary : "#6B7280",
      fontWeight: "500" as const,
      flexShrink: 1,
    },
    emptyState: {
      alignItems: "center",
      paddingVertical: 60,
      gap: 12,
    },
    emptyStateText: {
      fontSize: 15,
      color: "#CBD5E1",
      fontWeight: "500" as const,
    },
  });
}

const StockDetailsModalBody = ({ order, isDisplayViewOn }: any) => {
  const { isDark } = useAppTheme();
  const { t } = useTranslation();

  const excludedKeys = [
    "ItemCode",
    "InPallets",
    "FrgnName",
    "CardCode",
    "CardName",
    "ItmsGrpCod",
  ];

  const rawAvailable = Number(order?.OnHand || 0) - (order?.Quantity || 0) - (order?.Delivery || 0);
  const pieces = rawAvailable < 0 ? 0 : rawAvailable;
  const cartons = order?.PerCtns ? pieces / order.PerCtns : 0;
  const pallets = order?.PerCtns && order?.PerPallet ? Math.round(pieces / order.PerCtns / order.PerPallet) : 0;

  const orderedKeys = [
    "ItemName",
    "Location",
    "PerCtns",
    "PerPallet",
    "calculated_pieces",
    "calculated_cartons",
    "calculated_pallets",
    "OrderReserved",
    "OnWater",
    "OnOrder2",
    "Inventory Transferring",
  ];

  const specialLabels: any = {
    PerPallet: {
      oldLabel: "PerPallet",
      newLabel: t("totalPerPallet"),
      newValue:
        order?.PerPallet && order?.PerCtns
          ? (order.PerPallet * order.PerCtns).toLocaleString()
          : "-",
      supportingValue:
        order?.PerPallet && order?.PerCtns ? order.PerPallet.toString() : "-",
    },
    ItmsGrpCod: {
      oldLabel: "ItmsGrpCod",
      newLabel: t("display"),
      newValue: isDisplayViewOn ? t("perCartonLabel") : t("perPieceLabel"),
    },
    calculated_pieces: {
      oldLabel: "calculated_pieces",
      newLabel: t("piece"),
      newValue: pieces.toLocaleString(),
    },
    calculated_cartons: {
      oldLabel: "calculated_cartons",
      newLabel: t("carton"),
      newValue: Number(cartons.toFixed(1)).toLocaleString(),
    },
    calculated_pallets: {
      oldLabel: "calculated_pallets",
      newLabel: t("pallets"),
      newValue: Number(pallets.toFixed(1)).toLocaleString(),
    },
  };

  const detailItems: any = orderedKeys
    .filter((key) => !excludedKeys.includes(key))
    .map((key) => {
      if (specialLabels[key]) {
        const special = specialLabels[key];
        return {
          key,
          label: special.newLabel,
          value: special.newValue || order?.[key]?.toString() || "-",
          supportingValue: special.supportingValue,
        };
      } else {
        const rawValue = (order as any)?.[key];
        const isNumericField = ["OrderReserved", "OnWater", "OnOrder2", "Inventory Transferring"].includes(key);
        const formattedValue = isNumericField && rawValue !== undefined && rawValue !== null && rawValue !== "" && !isNaN(Number(rawValue))
          ? Number(rawValue).toLocaleString()
          : rawValue?.toString() || "-";

        return {
          key,
          label: translateFields(key, t, stockReportTranslationMap) || key,
          value: formattedValue,
        };
      }
    });

  const getGroup = (key: string) => {
    if (["ItemCode", "FrgnName", "CardCode", "CardName", "ItmsGrpCod", "ItemName", "Location", "PerCtns", "PerPallet"].includes(key)) return t("identifiers");
    if (["calculated_pieces", "calculated_cartons", "calculated_pallets"].includes(key)) return t("quantities");
    if (["OrderReserved", "OnWater", "OnOrder2", "Inventory Transferring"].includes(key)) return t("availability");
    return t("otherInformation");
  };

  const groupedItems = detailItems.reduce((acc: any, item: any) => {
    const group = getGroup(item.key);
    if (!acc[group]) acc[group] = [];
    acc[group].push(item);
    return acc;
  }, {} as Record<string, typeof detailItems>);

  const groupOrder = [
    t("identifiers"),
    t("quantities"),
    t("availability"),
    t("otherInformation"),
  ];

  const sortedGroups = Object.keys(groupedItems).sort((a, b) => {
    return groupOrder.indexOf(a) - groupOrder.indexOf(b);
  });

  return (
    <RNView style={{ flex: 1, paddingHorizontal: 16 }}>
      {sortedGroups.map((groupName) => (
        <RNView key={groupName} style={{ marginBottom: 16 }}>
          <RNView
            style={{
              backgroundColor: isDark ? "#2A2B2E" : "#F8FAFC",
              paddingVertical: 8,
              paddingHorizontal: 12,
              borderRadius: 6,
              marginBottom: 4,
            }}
          >
            <Text
              style={{
                fontSize: 13,
                color: isDark ? "#9CA3AF" : "#475569",
                fontWeight: "700",
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              {groupName}
            </Text>
          </RNView>
          <RNView style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {groupedItems[groupName].map((item: any) => (
              <RNView
                key={item.key}
                style={{
                  width: "50%",
                  paddingVertical: 12,
                  paddingHorizontal: 8,
                  borderBottomWidth: 1,
                  borderBottomColor: isDark ? "#374151" : "#F1F5F9",
                }}
              >
                <Text
                  selectable={true}
                  style={{
                    fontSize: 12,
                    color: isDark ? "#9CA3AF" : "#64748B",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    marginBottom: 6,
                    letterSpacing: 0.5,
                  }}
                >
                  {item.label}
                </Text>
                <RNView style={{ flexDirection: "row", alignItems: "baseline" }}>
                  <Text
                    selectable={true}
                    style={{
                      fontSize: 14,
                      color: isDark ? "#F9FAFB" : "#0F172A",
                      fontWeight: "500",
                    }}
                  >
                    {item.value?.toLocaleString()}
                  </Text>
                  {item.supportingValue && (
                    <Text selectable={true} style={{
                        fontSize: 12,
                        color: isDark ? "#9CA3AF" : "#64748B",
                        marginLeft: 8,
                    }}>
                      ({item.supportingValue?.toLocaleString()})
                    </Text>
                  )}
                </RNView>
              </RNView>
            ))}
          </RNView>
        </RNView>
      ))}
    </RNView>
  );
};
